'use es6';

import { applyDomFilters, getHtmlTransforms, getRemoveTransformsHandler } from '../../../utils/transformer';
function getPreProcessHandler(editor) {
  const {
    preProcess
  } = getHtmlTransforms(editor);
  return event => {
    // Skip transforms if called from an undo/redo in the content editor
    // as the content provided is the already processed/transformed markup.
    if (event.hsOrigin && event.hsOrigin === 'appUndoRedo') {
      return;
    }
    event.content = applyDomFilters(event.content, preProcess);
  };
}
function getPostProcessHandler(editor) {
  const {
    postProcess
  } = getHtmlTransforms(editor);
  return event => {
    event.content = applyDomFilters(event.content, postProcess);
  };
}
export default function initTransformerPlugin(editor) {
  editor.on('beforesetcontent', getPreProcessHandler(editor));
  editor.on('postprocess', getPostProcessHandler(editor));
  editor.on('remove', getRemoveTransformsHandler(editor));
}